// Solo visibilidad derivada del estado, como getEditContext en PHP. No concede
// acciones: sus permisos permanecen exactamente como fueron preparados.
export function startedVisitaPresentation(context) {
    return {...context,permissions:{...context.permissions,
        can_view_images_tab:context.permissions?.can_view_form_tab===true,
        can_view_observacion_general_tab:true}};
}
